<template>
    <div class="w-full h-full flex flex-col  gap-2 p-4 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] text-[var(--text)]">
        <div class="w-full flex gap-2 items-center">
            <h1 class="text-[var(--titulo)]  text-nowrap">{{ title }}</h1>
            <!-- <h3 class="text-[#ff9b05]">Produto</h3> -->
            <!-- <AppButton class=" text-[var(--text)] " v-bind:visibility="true" left_icon="fa-regular fa-circle-xmark fa-xl"
                emitType="close" @close="close" :width=23 :height=23 /> -->
        </div>
        <div v-for="(value, key) in data" :key="key">

            <div class="flex  text-[var(--text)] gap-2">
                <label :for="key" class="text-[var(--icon)]  min-w-28">{{ key }}: </label>
                <span v-if="key !== 'data'">{{ value == null ? 'N/A' : value }}</span>
                <span v-else>{{ value == null ? 'N/A' : formattedDate }}</span>
            </div>


        </div>

    </div>

</template>



<script>
import AppButton from './updated/button.vue'
import { format } from 'date-fns'
import { pt } from 'date-fns/locale'
export default {
    name: 'InfoCard',
    components: {
        AppButton
    },

    props: {
        data: {
            type: Object,
            default: {}
        },
        title: {
            type: String,
            default: 'Info Title'
        }

    },
    computed: {
        formattedDate() {
            const date = new Date(this.data.data);
            if (isNaN(date)) {
                return 'Data inválida';
            }
            return format(date, 'EEEE, dd MMMM yyyy', { locale: pt });
        },
    },

    data() {
        return {



        }
    },

    methods: {
        close() {
            this.$emit('close')
        }
    }

}

</script>





<style></style>